// ipakli-preview — Ipakli silk-route wedding card (w21).
//
// Silk-thread emerald wedding: outer card paper has a soft jade gradient
// trim; inner cream page holds a round photo medallion wreathed in a
// suzani-style stitch ring. "TO'Y MAROSIMI" eyebrow; Italiana names;
// small-caps date + venue caption. All colours from LayoutCtx.
import { Photo, type LayoutCtx } from "./_shared";

export function IpakliPreviewLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(150deg, ${accent}55 0%, ${accent}22 30%, ${bg} 55%, ${accent}22 80%, ${accent}55 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TO&apos;Y MAROSIMI
        </div>

        {/* Silk-stitch wreathed medallion */}
        <div style={{ width: "62%", aspectRatio: "1 / 1", position: "relative", marginBottom: "5%" }}>
          <svg viewBox="0 0 100 100" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} aria-hidden>
            <circle cx="50" cy="50" r="48" fill="none" stroke={accent} strokeWidth="0.5" strokeDasharray="2 1.5" opacity="0.8" />
            <circle cx="50" cy="50" r="44" fill="none" stroke={accent} strokeWidth="0.3" strokeDasharray="1 1" opacity="0.55" />
          </svg>
          <div
            style={{
              position: "absolute",
              inset: "6%",
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: `0 0 0 2px ${accent}55, 0 0 0 4px ${bg}`,
            }}
          >
            <Photo
              src={photo}
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
              fallback={
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: `radial-gradient(circle at 50% 45%, ${accent}55, ${bg})`,
                  }}
                />
              }
            />
          </div>
          {/* Four silk-knot ornaments around the ring */}
          {[0, 90, 180, 270].map((deg) => (
            <span
              key={deg}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: bg,
                border: `1px solid ${accent}`,
                transform: `rotate(${deg}deg) translate(0, calc(-50% - 50% + 2px))`,
                transformOrigin: "0 0",
              }}
              aria-hidden
            />
          ))}
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, fontWeight: 500, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TO&apos;Y MAROSIMI · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
